import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)
import Layout from '@/layout'

import {  getIsRoleMenu } from '@/utils/role'

const routes = [
  {
    path: '/',
    component: Layout,
    redirect: '/index',
    name: 'Index',
    meta: { title: '首页' ,icon:'el-icon-s-home'},

    children: [
      {
        path: '/index',
        name: 'Index',
        component: () => import('@/views/Index/index'),
        meta: { title: '首页',icon:'el-icon-s-home' , affix: true}
      }
    ]
  },
  {
    path: '/userSet',
    component: Layout,
    redirect: '/user-set',
    name: 'UserSet',
    meta: { title: '账户设置' ,icon:'el-icon-menu'},
    hidden:!getIsRoleMenu('UserSet'),
    children: [
      {
        path: '/user-set',
        name: 'user-set',
        component: () => import('@/views/userSet/index'),
        meta: { title: '账户设置',icon:'' , affix: true},
        hidden:!getIsRoleMenu('user-set'),
      }
    ]
  },

  {
    path: '/DeviceType',
    component: Layout,
    redirect: '/device-type',
    name: 'DeviceType',
    meta: { title: '设备类型管理' ,icon:'el-icon-menu'},
    hidden:!getIsRoleMenu('DeviceType'),
    children: [
      {
        path: '/device-type',
        name: 'device-type',
        component: () => import('@/views/deviceType/type'),
        meta: { title: '类型列表',icon:'' , affix: true},
        hidden:!getIsRoleMenu('device-type'),
      },
      {
        path: '/device-model',
        name: 'device-model',
        component: () => import('@/views/deviceType/model'),
        meta: { title: '型号列表',icon:'' , affix: true},
        hidden:!getIsRoleMenu('device-model'),
      }
    ]
  },
  {
    path: '/Device',
    component: Layout,
    redirect: '/device',
    name: 'Device',
    meta: { title: '设备管理' ,icon:'el-icon-menu'},
    hidden:!getIsRoleMenu('Device'),
    children: [
      {
        path: '/device',
        name: 'device',
        component: () => import('@/views/device/list'),
        meta: { title: '设备列表',icon:'' , affix: true},
        hidden:!getIsRoleMenu('device')
      },
      {
        path: '/not-active-device',
        name: 'not-active-device',
        component: () => import('@/views/device/notActiveDev'),
        meta: { title: '未激活设备',icon:'' , affix: true},
        hidden:!getIsRoleMenu('not-active-device')
      },
      {
        path: '/offline',
        name: 'offline',
        component: () => import('@/views/device/offline'),
        meta: { title: '设备离线统计',icon:'' , affix: true},
        hidden:!getIsRoleMenu('device_outline')
      },
    ]
  },
  {
    path: '/User',
    component: Layout,
    redirect: '/user',
    name: 'User',
    meta: { title: '用户管理' ,icon:'el-icon-menu'},
    hidden:!getIsRoleMenu('User'),
    children: [
      {
        path: '/user',
        name: 'user',
        component: () => import('@/views/user/user'),
        meta: { title: '用户列表',icon:'' , affix: true},
        hidden:!getIsRoleMenu('user'),
      }
    ]
  },
  {
    path: '/Question',
    component: Layout,
    redirect: '/question',
    name: 'Question',
    meta: { title: '常见问题' ,icon:'el-icon-menu'},
    hidden:!getIsRoleMenu('Question'),
    children: [
      {
        path: '/question',
        name: 'question-list',
        component: () => import('@/views/question/list'),
        meta: { title: '常见问题列表',icon:'' , affix: true},
        hidden:!getIsRoleMenu('question-list'),
      }
    ]
  },
  {
    path: '/Message',
    component: Layout,
    redirect: '/message',
    name: 'Message',
    meta: { title: '消息管理' ,icon:'el-icon-menu'},
    hidden:!getIsRoleMenu('Message'),
    children: [
      {
        path: '/message',
        name: 'message-list',
        component: () => import('@/views/message/list'),
        meta: { title: '消息列表',icon:'' , affix: true},
        hidden:!getIsRoleMenu('message-list'),
      }
    ]
  },
  {
    path: '/feedback',
    component: Layout,
    redirect: '/feedback',
    name: 'feedback',
    meta: { title: '问题反馈' ,icon:'el-icon-menu'},
    hidden:!getIsRoleMenu('feedback'),
    children: [
      {
        path: '/feedbackList',
        name: 'feedbackList',
        component: () => import('@/views/feedback/list'),
        meta: { title: '反馈列表',icon:'' , affix: true},
        hidden:!getIsRoleMenu('feedback_list'),
      }
    ]
  },
  {
    path: '/Content',
    component: Layout,
    redirect: '/about-us',
    name: 'content',
    meta: { title: '内容管理' ,icon:'el-icon-menu'},
    hidden:!getIsRoleMenu('content'),
    children: [
      {
        path: '/about-us',
        name: 'about-us',
        component: () => import('@/views/content/aboutUs'),
        meta: { title: '关于我们',icon:'' , affix: true},
        hidden:!getIsRoleMenu('about-us'),
      },
      {
        path: '/contact',
        name: 'contact',
        component: () => import('@/views/content/contact'),
        meta: { title: '联系方式',icon:'' , affix: true},
        hidden:!getIsRoleMenu('contact'),
      }
    ]
  },
  {
    path: '/System',
    component: Layout,
    redirect: '',
    name: 'System',
    meta: { title: '系统管理' ,icon:'el-icon-menu'},
    hidden:!getIsRoleMenu('System'),
    children: [
      {
        path: '/role',
        name: 'role',
        component: () => import('@/views/system/role'),
        meta: { title: '角色管理',icon:'' },
        hidden:!getIsRoleMenu('role'),
      },
      {
        path: '/member',
        name: 'member',
        component: () => import('@/views/system/member'),
        meta: { title: '成员管理',icon:'' },
        hidden:!getIsRoleMenu('member'),
      }
    ]
  },
  {
    path: '/login',
    component: () => import('@/views/login/index'),
    hidden: true
  },
  // {
  //   path: '/update-pwd',
  //   component: () => import('@/views/login/update-pwd'),
  //   hidden: true
  // },
  {
    path: '/deviceDetails',
    component: Layout,
    hidden: true,
    redirect: 'noredirect',
    children: [
      {
        path: '/device-details',
        name: 'device-details',
        component: () => import('@/views/device/details'),
        meta: { title: '设备详情',icon:'' , affix: true},
        hidden:false
      },{
        path: '/device-charts',
        name: 'device-charts',
        component: () => import('@/views/device/charts'),
        meta: { title: '历史数据',icon:'' , affix: true},
        hidden:false
      }
    ]
  },
  {
    path: '/404',
    component: () => import('@/views/404'),
    hidden: true
  },


  // 404 page must be placed at the end !!!
  { path: '*', redirect: '/404', hidden: true }
]

const router = new VueRouter({
  // mode: 'history', // 去掉url中的#
  mode: 'hash', // 去掉url中的#
  base: process.env.BASE_URL,
  routes
})
router.beforeEach((to, form, next) => {
  if (to.meta.title) {
    document.title = to.meta.title ;
  }
  next()
})

export default router
